<template>
  <section class="body">
    <!-- Progress bar -->
    <div
      v-if="loadingFormData"
      class="text-center mb-2"
    >
      <b-progress
        :value="loadingFormDataValue"
        show-progress
        class="m-5"
      />
    </div>

    <b-form
      v-else
      @submit.prevent="submit"
    >
      <b-form-row class="mb-2 justify-content-center">
        <DateCampaignModal
          :form="form.date"
        />
        <SiteModal :form="form" />
        <TargetGroupCampaignModal
          :field-data="form.target_group"
        />
        <FilmCodeModal
          :form="form"
        />
        <ProductAdvertiserAgencyModal :form="form" />
        <FilmTypeModal
          v-if="config_ShowFilmType"
          :form="form.filmTypes"
        />
        <ProductClassModal :form="form.product_class" />
        <CheckboxDropdownColumns
          id="column-select"
          :form-field="form.columns"
          name="Kolumner"
          @input="updateColumns"
        />
      </b-form-row>
      <b-form-row class="mb-2 justify-content-center">
        <button
          v-if="getSelectedInputs > 0"
          type="button"
          class="trashbtn mt-2 mr-2"
          @click="clearAllFields"
        >
          <b-icon-trash />
        </button>
        <div
          v-for="(selectedButton, key) in selectedBtns"
          :key="key"
        >
          <button
            class="selectedbtns mr-2 mt-2 bubblefontsize"
            type="button"
            @click="selectedButton.clickedBtn && selectedButton.clickedBtn()"
          >
            <span v-html="selectedButton.text" />
            <b-icon
              v-if="selectedButton.editable"
              class="ml-2 crossbtn"
              font-scale="1.5"
              icon="x"
              @click="
                selectedButton.clickedBtnDelete &&
                  selectedButton.clickedBtnDelete($event)
              "
            />
          </button>
        </div>
      </b-form-row>
      <b-form-row class="mb-2 justify-content-center align-items-end">
        <div
          v-if="config_ShowGrouping"
          class="group-by-div"
        >
          <label for="column-select">Gruppering</label>
          <v-select
            v-model="selectedGroup"
            :options="form.group.options"
            :clearable="false"
            class="col-sm-12 p-0"
          />
        </div>
        <div>
          <div class="col-0">
            <b-button
              :disabled="disableRunBtn"
              type="submit"
              class="ml-3"
              variant="primary"
              size="sm"
            >
              <b-icon
                v-if="!loadingSearchResults"
                icon="arrow-repeat"
              />
              {{ loadingSearchResults ? 'Arbetar...' : 'Kör' }}
            </b-button>
          </div>
        </div>
      </b-form-row>
    </b-form>
    <!-- Results -->
    <template v-if="initFirstSearch">
      <!-- Show if loading results -->
      <div
        v-if="!hasData && loadingSearchResults"
        class="text-center mb-2"
      >
        <hr>
        <b-spinner
          variant="primary"
          type="grow"
          label="Spinning"
        />
        <div>
          <small class="text-muted">Laddar sökresultat...</small>
        </div>
      </div>

      <!-- Show if not loading results -->
      <div>
        <!-- Show if search have hits -->
        <CampaignResult
          v-show="hasData"
          @sort-only="submitSort"
          :disabled="loadingSearchResults"
          :class="{ 'overlay-disabled': loadingSearchResults }"
        />

        <!-- Show if search have no hits -->
        <div
          v-if="!hasData && !loadingSearchResults"
          class="text-center"
        >
          <hr>
          <p>Inget sökresultat</p>
        </div>
      </div>
    </template>
    <SlowQueryModal 
      :show="showSlowQueryModal" 
      :loading="loadingExportResults" 
      @download="handleExportResults"
      @cancel="showSlowQueryModal = false" 
    />
    <ScheduleReportModal 
      :show="showScheduleReportModal" 
      :loading="loadingScheduleReport" 
      @submit="handleScheduleReportSubmit" 
      @cancel="showScheduleReportModal = false" 
    />
  </section>
</template>

<script>
import SlowQueryModal from "../../Shared/SlowQueryModal/SlowQueryModal.vue"
import ScheduleReportModal from "../../Shared/ScheduleReportModal/ScheduleReportModal.vue"
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/sv';
import FilmTypeModal from './FilmTypeModal.vue';
import ProductClassModal from './ProductClassModal.vue';
import CampaignResult from '../Campaign/CampaignResult';
import {
  addDays,
  isDateNotBetweenTwoDates,
  processCampaignResults,
  sleep
} from '../../../assets/js/utils.js';
import vSelect from 'vue-select';
//custom scripts
import { search, fetchFormFieldData } from '../../../assets/js/api.js';
import { downloadFile, createScheduledReportQuery } from '../../../assets/js/api.js';
import { bus } from '../../../main';
import { mapMutations, mapActions } from 'vuex';
import DateCampaignModal from '../Campaign/DateCampaignModal';
import SiteModal from '@/components/Shared/SiteModal';
import TargetGroupCampaignModal from './TargetGroupCampaignModal';
import FilmCodeModal from './FilmCodeModal';
import ProductAdvertiserAgencyModal from './ProductAvertiserAgencyModal.vue';
import CheckboxDropdownColumns from '../../Shared/CheckboxDropdownColumns.vue';

export default {
  name: 'Campaigns',
  components: {
    SlowQueryModal,
    ScheduleReportModal,
    CampaignResult,
    vSelect,
    FilmTypeModal,
    ProductClassModal,
    DateCampaignModal,
    SiteModal,
    TargetGroupCampaignModal,
    FilmCodeModal,
    ProductAdvertiserAgencyModal,
    CheckboxDropdownColumns,
  },

  data() {
    return {
      showScheduleReportModal: false,
      loadingScheduleReport: false,
      loadingExportResults:false,
      showSlowQueryModal: false,
      isTypingBuyingAgency: false,
      isTypingAdvert: false,
      isTypingProduct: false,
      disableColumnOptions: false,
      loadingFormData: true,
      loadingFormDataValue: 0,
      loadingFormDataMaxValue: 3,
      loadingSearchResults: false,
      initFirstSearch: false,
      formValidator: {
        dateFrom: true,
        dateTo: true,
      },
      form: {
        date: {
          datePicker: {
            weekdays: ['Må', 'Ti', 'On', 'To', 'Fr', 'Lö', 'Sö'],
            months: [
              'Januari',
              'Februari',
              'Mars',
              'April',
              'Maj',
              'Juni',
              'Juli',
              'Augusti',
              'September',
              'Oktober',
              'November',
              'December',
            ],
          },
          showDateCampaignModal: false
        },
        columns: {
          options: [],
          selected: []
        },
        group: {
          options: [
            { label: '-Ingen-', id: 'nobody' },
            { label: 'Datum', id: 'consumed_at' },
            { label: 'Site', id: 'site_name' },
            { label: 'Filmkod', id: 'filmCode' },
          ],
        },
        sites: {
          options: [],
          selected: [],
          showSiteModal: false,
          apiBodyGetter: "campaignApiBody/getPayload",
          apiBodySetter: "campaignApiBody/updatePayload"
        },
        target_group: {
            measurements: {
            options: [],
            selected: ''
          },
          showTargetGroupModal: false
        },
        advertisers: [],
        buyingAgencies: [],
        products: [],
        product_class: {
          showProductClassModal: false
        },
        filmcode: {
          filmCodeList: [],
          showFilmCodeModal: false
        },
        filmTypes: { 
          options: [
            { text: "Reklam", value: "S"  },
            { text: "Sponsring", value: "B"  }, 
            { text: "Trailer", value: "T"  }
          ],
          showFilmTypeModal: false
        },
        selectedFilmType: '',
        productAdvertiserAgency:{
          showProductAdvertiserAgencyModal: false
        }
      },
      getFilmcodeSelectListsData: false,
      selectedBtns: []
    };
  },
  computed: {
    allModalsClosed() {
      let allModalsClosed = false;
      if (
        !this.form.date.showDateCampaignModal &&
        !this.form.sites.showSiteModal &&
        !this.form.target_group.showTargetGroupModal &&
        !this.form.filmcode.showFilmCodeModal &&
        !this.form.productAdvertiserAgency.showProductAdvertiserAgencyModal &&
        !this.form.product_class.showProductClassModal &&
        !this.form.filmTypes.showFilmTypeModal
      )
        allModalsClosed = true;
      return allModalsClosed;
    },
    getSelectedInputs() {
      let selectedInputs = this.selectedBtns.length;
      return selectedInputs;
    },
    disableRunBtn() {
      let disableRunBtn = false;      
      if (this.loadingSearchResults || this.form.columns.selected.length === 0) disableRunBtn = true;
      return disableRunBtn;
    },
    selectedBuyingAgency: {
      get() {
        let buyingAgencyText = "";
        let payloadBuyingAgency = this.$store.state.campaignApiBody.payload.buyingAgency;
        if(payloadBuyingAgency && payloadBuyingAgency > 0){
          buyingAgencyText = this.form.buyingAgencies.find(
            b => b.id === payloadBuyingAgency
          ).label
        }
        return buyingAgencyText
      },
      set(newBuyingAgency) {
        this.$store.commit(
          'campaignApiBody/updateBuyingAgency',
            newBuyingAgency ? newBuyingAgency.id : -1
          );
      },
    },
    selectedAdvertiser: {
      get() {
        let advertiserText = "";
        let payloadAdvertiser = this.$store.state.campaignApiBody.payload.advertiser;
        if(payloadAdvertiser && payloadAdvertiser > 0){
          advertiserText = this.form.advertisers.find(
            b => b.id === payloadAdvertiser
          ).label
        }
        return advertiserText
      },
      set(newAdvertiser) {
        this.$store.commit(
          'campaignApiBody/updateAdvertiser',
            newAdvertiser ? newAdvertiser.id : -1
          );
      },
    },
    selectedProduct: {
      get() {
        let productText = "";
        let payloadProduct = this.$store.state.campaignApiBody.payload.product;
        if(payloadProduct && payloadProduct > 0){
          productText = this.form.products.find(
            b => b.id === payloadProduct
          ).label
        }
        return productText
      },
      set(newProduct) {
        this.$store.commit(
          'campaignApiBody/updateProduct',
            newProduct ? newProduct.id : -1
          );
      },
    },
    hasData() {
      return this.$store.state.campaignResults.results.length > 0;
    },
    selectedColumns() {
      return this.$store.state.campaignApiBody.payload.columns;
    },
    selectedGroup: {
      get() {
        return this.$store.state.campaignApiBody.payload.group_by;
      },
      set(newGroupBy) { 
        this.$store.commit('campaignApiBody/updateGroupBy', newGroupBy);
      },
    },
    start_date: {
      get() {
        let startDate = this.$store.state.campaignApiBody.payload.start_date;
        let publishedToDate = this.$store.state.systemInfo.publishedToDate;
        //setting date when no date is set
        if (!startDate && publishedToDate) {
          let newStartDate = addDays(publishedToDate, -2);
          if (this.isFromDateDisabled(new Date(newStartDate))) {
            newStartDate = this.$store.state.systemInfo.adPublishedFromDate;
          }
          this.$store.commit('campaignApiBody/updateStartDate', newStartDate);
          return newStartDate;
        }
        //setting date from clicking the calendar in the interface.
        else return startDate;
      },
      set(newStartDate) {
        if (!newStartDate)
          newStartDate = addDays(this.$store.state.systemInfo.publishedToDate, -13);
        this.$store.commit('campaignApiBody/updateStartDate', newStartDate);
        if (newStartDate && this.end_date) {
          this.setupAdvertisers(newStartDate, this.end_date);
          this.setupBuyingAgencies(newStartDate, this.end_date);
          this.setupProducts(newStartDate, this.end_date);
        }
      },
    },
    end_date: {
      get() {
        let endDate = this.$store.state.campaignApiBody.payload.end_date;
        //setting date when no date is set
        if (!endDate) {
          this.$store.commit(
            'campaignApiBody/updateEndDate',
            this.$store.state.systemInfo.publishedToDate,
          );
          return this.$store.state.systemInfo.publishedToDate;
        }
        //setting date from clicking the calendar in the interface.
        return endDate;
      },
      set(newEndDate) {
        if (!newEndDate) newEndDate = this.$store.state.systemInfo.publishedToDate;
        this.$store.commit('campaignApiBody/updateEndDate', newEndDate);
        if (this.start_date) {
          this.setupAdvertisers(this.start_date, newEndDate);
          this.setupBuyingAgencies(this.start_date, newEndDate);
          this.setupProducts(this.start_date, newEndDate);
        }
      },
    },
    payload(){
      return this.$store.getters["campaignApiBody/getPayload"]
    }
  },
  watch: {
    "$store.state.systemInfo.publishedToDate"(pubToDate){
      this.setDefaultStartDateEndDate(pubToDate)
    },
    payload: {
      handler() {
        let query = this.$store.state.campaignApiBody.payload
        let selectedBtns = [];
        selectedBtns.push(
          {
            text: `<span class="font-weight-bold">Konsumtionsdatum:</span> ${query.start_date} - ${query.end_date}`,
            editable: false,
            clickedBtn: () => {
              this.form.date.showDateCampaignModal = true;
            }
          })
        if (query.site_id) {
          let chosenText = query.site_id.length > 1 ? "valda" : "vald";
          selectedBtns.push({
            text: `<span class="font-weight-bold">Site:</span> (${query.site_id.length} ${chosenText})`,
            clickedBtn: () => {
              this.form.sites.showSiteModal = true;
            }
          });
        }
        let numberOfStoredTargets = this.getTargetGroupCount();
        if (numberOfStoredTargets > 0) {
          let chosenText = numberOfStoredTargets > 1 ? "valda" : "vald";
          selectedBtns.push({
            text: `<span class="font-weight-bold"> Målgrupp / Mått </span> ${numberOfStoredTargets} ${chosenText}`,
            editable: true,
            clickedBtn: () => {
              this.form.target_group.showTargetGroupModal = true;
            },
            clickedBtnDelete: event => {
              event.stopPropagation();
              this.removeTargets()
            }
          });
        }
        let numberOfStoredFilmCodes = this.getFilmCodesSelectedCount();
        if (numberOfStoredFilmCodes > 0) {
          let chosenText = numberOfStoredFilmCodes > 1 ? "valda" : "vald";
          selectedBtns.push({
            text: `<span class="font-weight-bold"> Filmkoder </span> ${numberOfStoredFilmCodes} ${chosenText}`,
            editable: true,
            clickedBtn: () => {
              this.form.filmcode.showFilmCodeModal = true;
            },
            clickedBtnDelete: event => {
              event.stopPropagation();
              this.removeFilmCodes();
            }
          });
        }
        if (query.buyingAgency !== -1) {
        selectedBtns.push({
          text: `<span class="font-weight-bold"> Byrå </span> ${this.form.buyingAgencies.find(b => b.id == query.buyingAgency).label}`,
          editable: true,
          clickedBtn: () => {
            this.form.productAdvertiserAgency.showProductAdvertiserAgencyModal = true;
          },
          clickedBtnDelete: event => {
            event.stopPropagation();
            this.payload.buyingAgency = -1;
          }
        });
      }
      if (query.advertiser !== -1) {
        selectedBtns.push({
          text: `<span class="font-weight-bold"> Annonsör </span> ${this.form.advertisers.find(a => a.id == query.advertiser).label}`,
          editable: true,
          clickedBtn: () => {
            this.form.productAdvertiserAgency.showProductAdvertiserAgencyModal = true;
          },
          clickedBtnDelete: event => {
            event.stopPropagation();
            this.payload.advertiser = -1;
          }
        });
      }
      if (query.product !== -1) {
        selectedBtns.push({
          text: `<span class="font-weight-bold"> Produkt </span> ${this.form.products.find(p => p.id == query.product).label}`,
          editable: true,
          clickedBtn: () => {
            this.form.productAdvertiserAgency.showProductAdvertiserAgencyModal = true;
          },
          clickedBtnDelete: event => {
            event.stopPropagation();
            this.payload.product = -1;
          }
        });
      }
      if (query.filmTypes.length > 0) {
        let filmTypesText = query.filmTypes.map(value => {
          const match = this.form.filmTypes.options.find(
            obj => obj.value === value
          );
          return match ? match.text : null; // Return text if found, otherwise null
        });
        selectedBtns.push({
          text: `<span class="font-weight-bold"> Filmtyp </span> ${filmTypesText.join(
            ", "
          )}`,
          editable: true,
          clickedBtn: () => {
            this.form.filmTypes.showFilmTypeModal = true;
          },
          clickedBtnDelete: event => {
            event.stopPropagation();
            this.payload.filmTypes = [];
          }
        });
      }
      if (query.productClasses && query.productClasses.length > 0) {
        let chosenText = query.productClasses.length > 1 ? "valda" : "vald";
        selectedBtns.push({
          text: `<span class="font-weight-bold"> Produktklass </span> ${query.productClasses.length} ${chosenText}`,
          editable: true,
          clickedBtn: () => {
            this.form.product_class.showProductClassModal = true;
          },
          clickedBtnDelete: event => {
            event.stopPropagation();
            this.payload.productClasses = [];
            localStorage.removeItem("savedProductClasses");
          }
        });
      }
        this.selectedBtns = selectedBtns;
      },     
      deep: true
    },
  },
  beforeDestroy() {
    // Clean up by removing the event listener when the component is destroyed
    document.removeEventListener("keyup", this.onKeyUp);
  },
  created() {
    let pubDate = this.$store.state.systemInfo.publishedToDate
    if(pubDate)
      this.setDefaultStartDateEndDate(pubDate);
  },
  async mounted() {
    if (!this.$store.state.systemInfo.fullAccess && !this.$store.state.systemInfo.advertiserAccess) {
      this.$router.push('/');
    }
    this.init();
  },
  async updated() {
    let campaignsQuery = this.$store.state.campaignApiBody.payload;
    if (campaignsQuery.start_date && campaignsQuery.end_date && !this.getFilmcodeSelectListsData) {
      this.getFilmcodeSelectListsData = true;
      this.setupAdvertisers(campaignsQuery.start_date, campaignsQuery.end_date);
      this.setupBuyingAgencies(campaignsQuery.start_date, campaignsQuery.end_date);
      this.setupProducts(campaignsQuery.start_date, campaignsQuery.end_date);
    }
  },
  methods: {
    ...mapMutations('campaignApiBody', ['emptyQueryKeys']),
    ...mapActions(['resetReachCampaignState']),



    async handleScheduleReportSubmit(reportname) {
      this.loadingScheduleReport = true
      try {
          let payload = {...this.$store.state.campaignApiBody };
          
          // kör frågan här
          await createScheduledReportQuery(reportname,payload);

          this.$bvToast.toast("Körningen är schemalagd, du får ett mail när den är klar.", {
              title: "Schemalgd körning",
              variant: "success",
              solid: true,
              autoHideDelay: 5000,
          })
      } catch (error) {
          this.loadingScheduleReport = false
          this.showScheduleReportModal = false
          this.$bvToast.toast("Det gick inte schemalägga rapportkörningen", {
              title: "Serverfel",
              variant: "danger",
              solid: true,
              autoHideDelay: 5000,
          })
      } finally {
          this.loadingScheduleReport = false
          this.showScheduleReportModal = false
      }



    },
    async handleExportResults() {
      try {
        this.loadingExportResults = true;
        let payload = { ...this.$store.state.campaignApiBody };
        await downloadFile('QueryCampaignData/DownloadExport', payload);
      } catch (error) {
        console.error('Failed to export results:', error);
        this.$bvToast.toast('Ett fel uppstod vid export av data. Försök igen senare.', {
          title: 'Export misslyckades', 
          variant: 'danger',
          solid: true
        });
      } finally {
        this.loadingExportResults = false;
        this.showSlowQueryModal = false;
      }
    },




    async init() {
      document.addEventListener("keyup", this.onKeyUp);
      this.loadingFormDataValue = 33;
      let columnsResponse = await fetchFormFieldData('ColumnTypes/CampaignColumns');   

      if(this.config_ShowFilmType == false)
      {
          columnsResponse = columnsResponse.filter(field => field.column_type !== 'type');         
      }
      if (columnsResponse.statusCode) {
        this.$bvToast.toast(columnsResponse.errorMessage, {
          title: 'Varning',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000,
        });
      } else {
        let columnsSelected = [];
        if (localStorage.getItem('columnsSelectedCampaign')) {
          columnsSelected = JSON.parse(localStorage.columnsSelectedCampaign);
        }

        for (let index in columnsResponse) {
          let selected =
            columnsSelected.length > 0
              ? columnsSelected.includes(columnsResponse[index].column_type)
              : columnsResponse[index].default_selection;

          let column = {
            text: columnsResponse[index].display_name,
            value: columnsResponse[index].column_type,
            selected,
          };
          this.form.columns.options.push(column);
        }
        this.loadingFormDataValue = 50;
      }
     

      //Fetch sites from api
      let sitesResponse = await fetchFormFieldData('Sites', 'Campaign');
      if (sitesResponse.statusCode) {
        this.$bvToast.toast(sitesResponse.errorMessage, {
          title: 'Varning',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000,
        });
      } else {
        for (let index in sitesResponse) {
          let site = {
            text: sitesResponse[index].site_name,
            value: sitesResponse[index].site_id,
            selected: true,
          };
          this.form.sites.options.push(site);
        }
        this.loadingFormDataValue = 66;
      }
      let siteValues = this.form.sites.options.map(s => s.value)
      this.updateSiteIds(siteValues);
      //Fetch measures types from api
      let measureTypeResponse = await fetchFormFieldData('MeasureTypes', 'Campaign');
      if (measureTypeResponse.statusCode) {
        this.$bvToast.toast(measureTypeResponse.errorMessage, {
          title: 'Varning',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000,
        });
      } else {
        for (let index in measureTypeResponse) {
          let measure = {
            text: measureTypeResponse[index].display_name,
            value: measureTypeResponse[index].measure_type,
            showReachSelector: measureTypeResponse[index].show_reach_selector,
            ...measureTypeResponse[index].show_reach_selector && {
              reachAbsHeader: measureTypeResponse[index].reach_abs_header,
              reachRelHeader: measureTypeResponse[index].reach_rel_header,
            },
          };
          this.form.target_group.measurements.options.push(measure);
        }
        this.form.target_group.measurements.selected = measureTypeResponse[0].measure_type;

        this.loadingFormDataValue = 100;
      }

      // Sleep so that the progress bar has time to finnish
      await sleep(600);
      this.$store.commit('systemInfo/updateAnyFormFieldsLoaded', true);
      this.loadingFormData = false;
    },
    getFilmCodesSelectedCount() {
      let storedFilmCodes = localStorage.getItem("savedFilmCodes")
        ? JSON.parse(localStorage.getItem("savedFilmCodes"))
        : [];

      return storedFilmCodes != null
        ? storedFilmCodes.length
        : 0;
    },
    removeFilmCodes() {
      const payload = {
        ...this.$store.getters["campaignApiBody/getPayload"],
        filmcodes: []
      };
      this.$store.commit(
          'campaignApiBody/updatePayload',
          payload,
        );
      localStorage.removeItem("savedFilmCodes");
    },
    getTargetGroupCount() {
      let storedTargets = localStorage.getItem("campaignMeasures")
        ? JSON.parse(localStorage.getItem("campaignMeasures"))
        : [];

      return storedTargets != null
        ? storedTargets.length
        : 0;
    },
    removeTargets(){
      const updatedPayload = {
        ...this.$store.getters["campaignApiBody/getPayload"],
        measures: []
      };
      this.$store.commit(
        'campaignApiBody/updatePayload',
        updatedPayload,
      );            
      localStorage.removeItem("campaignMeasures");
    },
    setDefaultStartDateEndDate(pubDate){
      let newStartDate = addDays(pubDate, -2);
      this.$store.commit('campaignApiBody/updateStartDate', newStartDate);
      this.$store.commit("campaignApiBody/updateEndDate", pubDate);
    },
    clearAllFields(){
      
        //reset from and to date
        this.$store.commit('campaignApiBody/updateEndDate',this.$store.state.systemInfo.publishedToDate);

        let newStartDate = addDays(this.$store.state.systemInfo.publishedToDate, -2);
        
        this.$store.commit('campaignApiBody/updateStartDate', newStartDate);
        //reset sites
        this.$store.commit('campaignApiBody/updateSiteIds', []);
        //reset measures
         localStorage.removeItem("campaignMeasures");
         this.$store.commit('campaignApiBody/updateMeasures', []);
         this.$store.commit('campaignReachApiBody/updateMeasures', []);
        //reset filmcodes
        localStorage.removeItem("savedFilmCodes");
         this.$store.commit('campaignApiBody/updateFilmCodes', []); 
        //reset product classes
        localStorage.removeItem("savedProductClasses");

        this.$store.commit('campaignApiBody/updateProductClasses', []);
         //reset buying agency
        this.$store.commit('campaignApiBody/updateBuyingAgency',-1);
        //reset advertiser
        this.$store.commit('campaignApiBody/updateAdvertiser', -1);
        //reset product
        this.$store.commit('campaignApiBody/updateProduct',-1);
        //reset filmtype
        this.updateFilmType([])
        //reset group
        this.selectedGroup = {id: "nobody", label: "-Ingen-"};
        //reset campaing columns
        let defaultCols = this.form.columns.options.filter(c => c.selected).map(c => c.value)
        this.$store.commit('campaignApiBody/updateColumns', defaultCols);
        this.form.columns.selected = defaultCols;
      },

    onSearchBuyingAgencyBlur() {
      this.isTypingBuyingAgency = false;
    },
    onSearchBuyingAgency(value) {
      this.isTypingBuyingAgency = value && value.length > 0;
    },
    onSearchBlurAdvert() {
      this.isTypingAdvert = false;
    },
    onSearchAdvert(value) {
      this.isTypingAdvert = value && value.length > 0;
    },
    onSearchBlurProduct() {
      this.isTypingProduct = false;
    },
    onSearchProduct(value) {
      this.isTypingProduct = value && value.length > 0;
    },
    updateFilmType(value)
    {
      this.$store.commit('campaignApiBody/updateFilmTypes', value); 
    },
    updateColumns(value) {
      this.$store.commit('campaignApiBody/updateColumns', value);

      //Add to local storage
      if (value.length > 0) {
        localStorage.columnsSelectedCampaign = JSON.stringify(value);
      } else {
        //Removes data from local storage if length is 0 and if the keys exist
        if (localStorage.getItem('columnsSelectedCampaign')) {
          localStorage.removeItem('columnsSelectedCampaign');
        }
      }
    },
    async setupAdvertisers(startDate, endDate) {
      let advertisers = await search('Spot/AdvertiserSearch', {
        From: startDate,
        To: endDate,
      });
      this.form.advertisers = advertisers;
    },
    async setupBuyingAgencies(startDate, endDate) {
      let buyingAgencies = await search('Spot/BuyingAgencySearch', {
        From: startDate,
        To: endDate,
      });
      this.form.buyingAgencies = buyingAgencies;
    },
    async setupProducts(startDate, endDate) {
      let products = await search('Spot/ProductNameSearch', {
        From: startDate,
        To: endDate,
      });
      this.form.products = products;
    },

    isFromDateDisabled(date) {
      let disableDate = isDateNotBetweenTwoDates(
        date,
        new Date(this.$store.state.systemInfo.adPublishedFromDate),
        new Date(this.$store.state.systemInfo.publishedToDate),
      );
      return disableDate;
    },
    isEndDateDisabled(date) {
      let disableDate = isDateNotBetweenTwoDates(
        date,
        new Date(this.$store.state.systemInfo.adPublishedFromDate),
        new Date(this.$store.state.systemInfo.publishedToDate),
      );
      return disableDate;
    },
    updateSiteIds(value) {
      this.$store.commit('campaignApiBody/updateSiteIds', value);
      this.$store.commit('campaignReachApiBody/updateSiteIds', value);
    },
    async submitSort() {
      this.loadingSearchResults = true;
      const apiBody = this.$store.state.campaignApiBody;
      
      // Store current selections before the sort
      const selectedRows = this.$store.state.campaignResults.results
        .filter(item => item.valda)
        .map(item => item.rowNum);
      
      try {
        const response = await search('QueryCampaignData', apiBody);
        const campaignResults = response;
        this.$store.commit('campaignResults/updateRowCount', response.info.total_row_count);
        
        // Process results but preserve selections
        processCampaignResults(campaignResults, this.$store);
        
        // Restore selections based on rowNum
        selectedRows.forEach(rowNum => {
          this.$store.commit('campaignResults/select', rowNum);
        });
        
      } catch (error) {
        this.$bvToast.toast('Okänt serverfel vid hämtning av sökresultat', {
          title: 'Fel',
          variant: 'danger',
          solid: true,
          autoHideDelay: 10000,
        });     
        this.$store.commit('campaignResults/updateResults', []);
        this.$store.commit('campaignResults/updateResultFields', []);
      } finally {
        this.loadingSearchResults = false;
      }
    },
    async submit() {
      if (
        this.$store.state.campaignApiBody.payload.start_date >
        this.$store.state.campaignApiBody.payload.end_date
      ) {
        this.$bvToast.toast('Från-datum får inte vara större än till-datum.', {
          title: 'Ej giltig sökperiod',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
          bodyOutputType: 'trustedHtml',
        });
        return;
      }
      if (
        this.$store.state.campaignApiBody.payload.start_date <
        this.$store.state.systemInfo.adPublishedFromDate
      ) {
        this.$bvToast.toast(
          'Perioden får inte starta före ' + this.$store.state.systemInfo.adPublishedFromDate + '.',
          {
            title: 'Ej giltig sökperiod',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
            bodyOutputType: 'trustedHtml',
          },
        );
        return;
      }
      if (
        this.$store.state.campaignApiBody.payload.end_date >
        this.$store.state.systemInfo.publishedToDate
      ) {
        this.$bvToast.toast(
          'Till-datum får inte vara större än senast publicerings datum som är ' +
            this.$store.state.systemInfo.publishedToDate +
            '.',
          {
            title: 'Ej giltig sökperiod',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
            bodyOutputType: 'trustedHtml',
          },
        );
        return;
      }
      if (
        this.$store.state.campaignApiBody.payload.start_date.length > 0 &&
        this.$store.state.campaignApiBody.payload.end_date.length > 0 &&
        !this.loadingSearchResults
      ) {
        this.formValidator.dateFrom = true;
        this.formValidator.dateTo = true;
        this.initFirstSearch = true;
        this.loadingSearchResults = true;
        let apiBody = this.$store.state.campaignApiBody;
        bus.$emit('searching', 713);
        this.$store.commit('campaignApiBody/updateLastRowNum', 0);
        if (apiBody.payload.measures.length > 0) {
          this.$store.commit('campaignApiBody/updateSortDirection', 'DESC');
          this.$store.commit('campaignApiBody/updateSortBy', 'measure_1');
        } else {
          this.$store.commit('campaignApiBody/updateSortBy', null);
          this.$store.commit('campaignApiBody/updateSortDirection', 'ASC');
        }
        let campaignResults = null;
        this.resetReachCampaignState();
        this.$store.commit('campaignResults/setSumVisible', false);
        this.$store.commit('campaignApiBody/updateExcludedRows', []);

        this.$store.commit('campaignResults/updateResults', []);
        this.$store.commit('campaignResults/updateResultFields', []);

        try {
          const queryCost = await search('QueryCampaignData/QueryCost', apiBody);
          
          if(queryCost.queryClass === 'Normal') {
            const response = await search('QueryCampaignData', apiBody);
            campaignResults = response;
            this.$store.commit('campaignResults/updateRowCount', response.info.total_row_count);
            this.emptyQueryKeys();
            processCampaignResults(campaignResults, this.$store);
          } else if (queryCost.queryClass === 'RowLimitExceeded') {
            this.loadingSearchResults = false;
            this.$store.commit('searchResults/updateResults', []);
            this.$store.commit('searchResults/updateResultFields', []);
            this.showSlowQueryModal = true;
            return;
          } else if (queryCost.queryClass === 'Schedule') {
            this.loadingSearchResults = false;
            this.$store.commit('searchResults/updateResults', []);
            this.$store.commit('searchResults/updateResultFields', []);
            this.showScheduleReportModal = true;
            return;
          } else if (queryCost.queryClass === 'Forbidden') {
            this.loadingSearchResults = false;
            this.$bvToast.toast('Körningen är för omfattande', {
              title: 'Fel',
              variant: 'danger',
              solid: true,
              autoHideDelay: 10000,
            });
            this.$store.commit('searchResults/updateResults', []);
            this.$store.commit('searchResults/updateResultFields', []);
            return;
          }
        } catch (error) {
          this.loadingSearchResults = false;
          this.$bvToast.toast('Okänt serverfel vid hämtning av sökresultat', {
            title: 'Fel',
            variant: 'danger',
            solid: true,
            autoHideDelay: 10000,
          });     
          this.$store.commit('campaignResults/updateResults', []);
          this.$store.commit('campaignResults/updateResultFields', []);
          return;
        }

        this.loadingSearchResults = false;
      } else {
        this.formValidator.dateFrom =
          this.$store.state.campaignApiBody.payload.start_date.length > 0;
        this.formValidator.dateTo = this.$store.state.campaignApiBody.payload.end_date.length > 0;
      }
    },
    onKeyUp(event) {
      if (event.key === "Enter" && this.allModalsClosed) {
        this.submit();
      }
    },
  },
};
</script>

<style scoped>
:deep(.vs__dropdown-toggle) {
  font-family: inherit;
  width: 100%;
  position: relative;
}
.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
:deep(label) {
  margin-bottom: 0.25rem;
}
.wildcardCbxText {
  font-size: small;
}
.dropDown {
  font-size: small !important;
}
.supportTextNoAnswers {
  font-size: 0.8em;
  font-style: italic;
}
.v-select {
  width: 10rem;
  font-size: 0.875rem;
}
.filmTypeIcon {
  transform: scale(1.2);
  margin-left: 0.13rem;
}
.filmTypeContainer {
  float: right;
  margin-top: 0.5rem;
  height: 0.8rem;
}
.dropdown {
  width: 100%;
}
.elipsis-text {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
:deep(.vs__selected-options) {
  height: 1.6rem;
}
:deep(.vs__selected) {
  display: block !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
  max-width: 100% !important;
  overflow: hidden !important;
  font-weight: 300 !important;
}
:deep(.elipsis-truncate) {
  display: block !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
  max-width: 100% !important;
  overflow: hidden !important;
}
.hidden-selection {
  color: transparent !important;
}
:deep(.selectedDropdown .vs__selected-options) {
  flex-wrap: nowrap;
  max-width: calc(100% - 40px);
}
:deep(.selectedDropdown .vs__dropdown-toggle) {
  background-color: #e5f3ff;
  color: #6c757d;
}
</style>
